import { render, staticRenderFns } from "./RideCreditPage.vue?vue&type=template&id=966c4b3e&"
import script from "./RideCreditPage.vue?vue&type=script&lang=js&"
export * from "./RideCreditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports